import React, { memo, useEffect, useRef, useState } from 'react'
import './index.less'
import { message, Modal, Space } from 'antd'
import ModalBase from '../ModalBase'
import { getConfigList } from '@/api/modules/community'

type ContactUsProps = {
    open: boolean
    onClose: () => void
}

const ContactUs: React.FC<ContactUsProps> = memo((props) => {

    const { open, onClose } = props
    const [data, setData] = useState<any[]>()


    useEffect(() => {
        if (!open) return
        getConfigList({ code: 'CONTACT_US', type: 'PLATFORM_CONFIG' }).then((res) => {
            setData(res ?? {})
        }).catch((err: any) => { message.error(err.message) })
    }, [open])

    return <>
        <ModalBase
            open={open}
            onCancel={onClose}
            footer={false}
            title={data?.[0]?.name}
            width={460}
        >
            <Space size={20} className='os-center'>
                {
                    data?.map((item) => {
                        return <Space direction='vertical' size={8} align='center' >
                            <img style={{ width: 120 }} src={item.config?.url} alt="" />
                            <span style={{ color: '#333333' }} >{item.config?.title}</span>
                        </Space>
                    })
                }
            </Space>
        </ModalBase>
    </>
})

export default ContactUs